module.exports = __webpack_public_path__ + "img/at.ca7fbc0c.svg";